{
  "chart_url": "https://dev.hearthfire.ai/chart/AAPL",
  "cooldown_hours": "24",
  "direction_color": "#16a34a",
  "direction_prefix": "Buy alert",
  "disable_rule_url": "https://dev.hearthfire.ai/alerts?rule=01HXAMPLE",
  "fired_at_human": "May 10, 2026 at 6:32 PM",
  "interpretation_paragraph_1": "RSI dropping under 30 is the classic oversold reading. Mean-reversion traders look for an entry here when they're already bullish on the name and want to add at a lower price; the bounce off oversold is one of the most-watched setups in technical analysis.",
  "interpretation_paragraph_2": "Caveat: in a strong downtrend, RSI can stay under 30 for weeks. Trend-followers wait for confirmation (RSI back above 30 plus a higher-low in price) before acting. Oversold is a signal, not a green light.",
  "journal_url": "https://dev.hearthfire.ai/journal?ticker=AAPL",
  "last_close": "$182.34",
  "last_fired_human": "never",
  "rule_name": "AAPL oversold reentry",
  "rule_summary_plain": "RSI(14) dropped below 30 (oversold)",
  "rule_value": "28.4",
  "ticker": "AAPL"
}
